'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    width: 80% !important;\n    margin: 20px auto 0 !important;\n  '], ['\n    width: 80% !important;\n    margin: 20px auto 0 !important;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    width: 90% !important;\n    padding-bottom: 30px !important;\n  '], ['\n    width: 90% !important;\n    padding-bottom: 30px !important;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    width: 90%;\n  '], ['\n    width: 90%;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  '], ['\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _colors = require('HubStyleTokens/colors');

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _UICardWrapper = require('UIComponents/card/UICardWrapper');

var _UICardWrapper2 = _interopRequireDefault(_UICardWrapper);

var _UICardSection = require('UIComponents/card/UICardSection');

var _UICardSection2 = _interopRequireDefault(_UICardSection);

var _HighlightedMerchBizObjectives = require('self-service-api/constants/HighlightedMerchBizObjectives');

var _HighlightedMerchBizObjectives2 = _interopRequireDefault(_HighlightedMerchBizObjectives);

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _CurrentPlanTag = require('pricing-pages-unified-ui/components/common/CurrentPlanTag');

var _CurrentPlanTag2 = _interopRequireDefault(_CurrentPlanTag);

var _HighlightedMerchHeaderConfig = require('pricing-pages-unified-ui/constants/HighlightedMerchHeaderConfig');

var _HighlightedMerchHeaderConfig2 = _interopRequireDefault(_HighlightedMerchHeaderConfig);

var _MerchCardCTAsContainer = require('pricing-pages-unified-ui/components/product-pages/MerchCardCTAsContainer');

var _MerchCardCTAsContainer2 = _interopRequireDefault(_MerchCardCTAsContainer);

var _ProductOwnershipSelectors = require('pricing-pages-unified-ui/selectors/ProductOwnershipSelectors');

var _HighlightedMerchPriceDisplay = require('pricing-pages-unified-ui/components/product-pages/HighlightedMerchPriceDisplay');

var _HighlightedMerchPriceDisplay2 = _interopRequireDefault(_HighlightedMerchPriceDisplay);

var _BizObjectives = require('pricing-pages-unified-ui/components/product-pages/BizObjectives');

var _BizObjectives2 = _interopRequireDefault(_BizObjectives);

var _ViewAllFeatures = require('pricing-pages-unified-ui/components/product-pages/ViewAllFeatures');

var _ViewAllFeatures2 = _interopRequireDefault(_ViewAllFeatures);

var _Terms = require('self-service-api/constants/Terms');

var _CodeSplitEnvWrapper = require('pricing-pages-unified-ui/components/CodeSplitEnvWrapper');

var _CodeSplitEnvWrapper2 = _interopRequireDefault(_CodeSplitEnvWrapper);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _publicPageUrls = require('pricing-pages-unified-ui/utils/publicPageUrls');

var _SkeletonLoadWrapper = require('../loading/SkeletonLoadWrapper');

var _SkeletonLoadWrapper2 = _interopRequireDefault(_SkeletonLoadWrapper);

var _RequestStatusTypes = require('pricing-pages-unified-ui/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledCardWrapper = (0, _styledComponents2.default)(_UICardWrapper2.default).withConfig({
  displayName: 'HighlightedMerchCard__StyledCardWrapper'
})(['border:1px solid ', ';z-index:1;box-shadow:none !important;&.feature-highlight{box-shadow:0 0 5px ', ' !important;}&.no-term-selector-variant-above{margin-top:20px;}', ';', ';'], _colors.BATTLESHIP, _colors.OZ, _responsiveBreakpoints2.default.tabletPortrait(_templateObject), _responsiveBreakpoints2.default.phone(_templateObject2));

var StyledCTAsWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'HighlightedMerchCard__StyledCTAsWrapper'
})(['margin:0 auto;width:80%;text-align:center;button,a{width:100%;line-height:23px;}', ';'], _responsiveBreakpoints2.default.tablet(_templateObject3));

var StyledCardSection = (0, _styledComponents2.default)(_UICardSection2.default).withConfig({
  displayName: 'HighlightedMerchCard__StyledCardSection'
})(['padding:40px 40px 20px !important;&.term-selector-variant-inside{padding:40px 40px 20px !important;}&.no-term-selector-variant-inside{padding-bottom:62px !important;}&.no-term-selector-variant-above{padding-top:44px !important;}&.term-selector-variant-above{padding-top:24px !important;}', ';'], _responsiveBreakpoints2.default.tablet(_templateObject4));

var HighlightedMerchCard = function HighlightedMerchCard(_ref) {
  var merchandiseId = _ref.merchandiseId,
      ownsProduct = _ref.ownsProduct,
      hub = _ref.hub,
      purchaseMotionRequestStatus = _ref.purchaseMotionRequestStatus;

  var _useState = (0, _react.useState)(_Terms.MONTHLY),
      _useState2 = _slicedToArray(_useState, 2),
      activeTerm = _useState2[0],
      setActiveTerm = _useState2[1];

  var headerConfig = _HighlightedMerchHeaderConfig2.default[merchandiseId];
  var title = headerConfig.title,
      includes = headerConfig.includes,
      icon = headerConfig.icon;

  var edition = _ImmutableMerchandiseIdMap2.default[merchandiseId].edition;

  return _react2.default.createElement(
    StyledCardWrapper,
    { 'data-selenium-id': merchandiseId + '-merch-card' },
    ownsProduct && _react2.default.createElement(_CurrentPlanTag2.default, null),
    _react2.default.createElement(
      StyledCardSection,
      null,
      _react2.default.createElement(
        _UIFlex2.default,
        { justify: 'between', direction: 'row' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_UIImage2.default, { className: 'display-inline', src: icon }),
          _react2.default.createElement(
            'h2',
            { className: 'm-bottom-0' },
            _react2.default.createElement(_FormattedMessage2.default, { message: title })
          ),
          _react2.default.createElement(
            _Small2.default,
            { use: 'help' },
            _react2.default.createElement(_FormattedMessage2.default, { message: includes })
          )
        ),
        _react2.default.createElement(
          _SkeletonLoadWrapper2.default,
          {
            isLoading: purchaseMotionRequestStatus !== _RequestStatusTypes2.default.SUCCEEDED,
            heights: ['0.75em', 30, 10],
            widths: [60, 60, 60]
          },
          _react2.default.createElement(_HighlightedMerchPriceDisplay2.default, {
            activeTerm: activeTerm,
            merchandiseId: merchandiseId
          })
        )
      ),
      _react2.default.createElement(_CodeSplitEnvWrapper2.default, {
        authedComponentLoader: function authedComponentLoader() {
          return import( /* webpackChunkName: "authed-chunk" */'pricing-pages-unified-ui/components/product-pages/MerchCardTermSelectorContainer');
        },
        authedComponentProps: {
          activeTerm: activeTerm,
          onChange: function onChange(term) {
            return setActiveTerm(term);
          },
          merchandiseId: merchandiseId
        }
      })
    ),
    _react2.default.createElement(
      StyledCTAsWrapper,
      null,
      _react2.default.createElement(
        _SkeletonLoadWrapper2.default,
        {
          isLoading: purchaseMotionRequestStatus !== _RequestStatusTypes2.default.SUCCEEDED,
          heights: [50]
        },
        _react2.default.createElement(_MerchCardCTAsContainer2.default, {
          activeTerm: activeTerm,
          merchandiseId: merchandiseId,
          hub: hub
        })
      )
    ),
    _react2.default.createElement(_BizObjectives2.default, {
      merchandiseId: merchandiseId,
      hub: hub,
      inSingleColumnPriceDisplay: true
    }),
    _react2.default.createElement(
      StyledCardSection,
      null,
      _react2.default.createElement(_ViewAllFeatures2.default, {
        hub: hub,
        edition: edition,
        gaClassName: (0, _publicPageUrls.getGAClassName)('' + hub + edition + '-pricing-features')
      })
    )
  );
};

HighlightedMerchCard.propTypes = {
  merchandiseId: _react.PropTypes.oneOf(Object.keys(_HighlightedMerchBizObjectives2.default).map(function (id) {
    return parseInt(id, 10);
  })).isRequired,
  hub: _react.PropTypes.string.isRequired,
  ownsProduct: _react.PropTypes.bool.isRequired,
  purchaseMotionRequestStatus: _react.PropTypes.string.isRequired
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var merchandiseId = _ref2.merchandiseId;
  return {
    ownsProduct: (0, _ProductOwnershipSelectors.ownsProductSelector)(state, merchandiseId),
    purchaseMotionRequestStatus: state.purchaseMotionRequestStatus
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(HighlightedMerchCard);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/HighlightedMerchCard.js
// module id = 747
// module chunks = 3 4